import React from 'react';

// Wordmark where the capital "L" in Lucrum is drawn as a bar chart:
// navy axes (the letter "L") with three ascending gold bars rising inside it.
const Logo = ({ className = '' }) => {
    return (
        <span className={`inline-flex items-baseline font-black tracking-tight text-terra-blue-900 leading-none ${className}`}>
            Terra
            <span className="inline-flex items-baseline text-terra-gold-500">
                <svg
                    viewBox="0 0 26 30"
                    style={{ height: '0.82em', width: 'auto', marginLeft: '0.5px', marginRight: '0.5px', transform: 'translateY(0.04em)' }}
                    className="text-terra-blue-900"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                >
                    {/* the "L" axes — follow the wordmark's navy */}
                    <path d="M6 3 V26 H23" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                    {/* ascending bars (gold) */}
                    <rect x="10.5" y="19" width="3" height="5" rx="1" fill="#D8AB3D" />
                    <rect x="15" y="15" width="3" height="9" rx="1" fill="#D8AB3D" />
                    <rect x="19.5" y="10" width="3" height="14" rx="1" fill="#D8AB3D" />
                </svg>
                ucrum
            </span>
        </span>
    );
};

export default Logo;
